import React, { useEffect, useState } from "react";
import "../css/Payments.css";

const Payments = () => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedPayment, setSelectedPayment] = useState(null);

  useEffect(() => {
    fetchPayments();
  }, []);

  const fetchPayments = async () => {
    try {
      setLoading(true);
      const res = await fetch("/api/admin/payments");
      if (!res.ok) throw new Error("Failed to fetch payments");
      const data = await res.json();
      setPayments(data.success ? data.data || [] : []);
    } catch (error) {
      console.error("FETCH PAYMENTS ERROR:", error);
      setPayments([]);
    } finally {
      setLoading(false);
    }
  };

  const formatPaiseToRupees = (amount) => {
  return `₹${((amount || 0) / 100).toFixed(2)}`;
};

  const closeModal = () => setSelectedPayment(null);

  /* ── small helpers ── */
  const Row = ({ label, value, mono = false }) => (
    <p>
      <strong>{label}:</strong>
      <span style={mono ? { fontFamily: "var(--mono)", fontSize: 12 } : {}}>
        {value || "-"}
      </span>
    </p>
  );

  return (
    <div className="payments-page">

      {/* HEADER */}
      <div className="payments-header">
        <div>
          <h1>Payments</h1>
          <p>Monitor all booking payments and transaction details</p>
        </div>
        <div className="payments-count">{payments.length} Payments</div>
      </div>

      {/* TABLE */}
      <div className="payments-table-wrapper">
        <table className="payments-table">
          <thead>
            <tr>
              <th>Booking ID</th>
              <th>Customer</th>
              <th>Vehicle</th>
              <th>Amount</th>
              <th>Status</th>
              <th>Method</th>
              <th>Payment ID</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr><td colSpan="8">Loading payments…</td></tr>
            ) : payments.length === 0 ? (
              <tr><td colSpan="8">No payments found</td></tr>
            ) : (
              payments.map((item, index) => {
                const customer        = item.customer        || {};
                const transaction     = item.transaction     || {};
                const razorpayPayment = item.razorpayPayment || {};

                return (
                  <tr key={index}>
                    <td className="booking-id">{item.booking_id}</td>

                    <td>
                      <div className="customer-name">{customer.full_name || "-"}</div>
                      <div className="customer-phone">{customer.phone || "-"}</div>
                    </td>

                    <td>{item.modelname || "-"}</td>

                    <td>₹{Number(transaction.amount || 0).toFixed(2)}</td>

                    <td>
                      <span className={`status-badge ${transaction.payment_status || ""}`}>
                        {transaction.payment_status || "-"}
                      </span>
                    </td>

                    <td>{razorpayPayment.method || "-"}</td>

                    <td className="payment-id">{transaction.payment_id || "-"}</td>

                    <td>
                      <button
                        className="view-btn"
                        onClick={() =>
                          setSelectedPayment({ ...item, customer, transaction, razorpayPayment })
                        }
                      >
                        View
                      </button>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      {/* MODAL */}
      {selectedPayment && (
        <div className="payment-modal-overlay" onClick={closeModal}>
          <div className="payment-modal" onClick={(e) => e.stopPropagation()}>

            {/* MODAL HEADER */}
            <div className="modal-header">
              <h2>Payment Details</h2>
              <button className="close-btn" onClick={closeModal}>×</button>
            </div>

            {/* MODAL CONTENT */}
            <div className="modal-content">

              {/* BOOKING */}
              <div className="detail-group">
                <h3>Booking</h3>
                <Row label="Booking ID" value={selectedPayment.booking_id}              mono />
                <Row label="Vehicle"    value={selectedPayment.modelname} />
                <Row label="Price"      value={`₹${selectedPayment.transaction?.amount || 0}`} />
              </div>

              {/* CUSTOMER */}
              <div className="detail-group">
                <h3>Customer</h3>
                <Row label="Name"  value={selectedPayment.customer?.full_name} />
                <Row label="Phone" value={selectedPayment.customer?.phone}  mono />
                <Row label="Email" value={selectedPayment.customer?.email}  mono />
                <Row label="City"  value={selectedPayment.customer?.city} />
              </div>

              {/* PAYMENT */}
              <div className="detail-group">
                <h3>Payment</h3>
                <Row label="Status"     value={selectedPayment.transaction?.payment_status} />
                <Row label="Payment ID" value={selectedPayment.transaction?.payment_id}     mono />
                <Row label="Method"     value={selectedPayment.razorpayPayment?.method} />
                <Row label="Bank"       value={selectedPayment.razorpayPayment?.bank} />
                <Row label="VPA"        value={selectedPayment.razorpayPayment?.vpa}        mono />
                <Row label="RRN"        value={selectedPayment.razorpayPayment?.acquirer_rrn} mono />
              </div>

              {/* GATEWAY */}
              {/* GATEWAY */}
<div className="detail-group">

  <h3>
    Gateway Details
  </h3>

  <Row
    label="Razorpay Status"
    value={
      selectedPayment
        .razorpayPayment?.status
    }
  />

  <Row
    label="Gateway Fee"
    value={formatPaiseToRupees(
      selectedPayment
        .razorpayPayment?.fee
    )}
  />

  <Row
    label="Tax"
    value={formatPaiseToRupees(
      selectedPayment
        .razorpayPayment?.tax
    )}
  />

  <Row
    label="Refunded"
    value={formatPaiseToRupees(
      selectedPayment
        .razorpayPayment
        ?.amount_refunded
    )}
  />

  <Row
    label="Net Amount Received"
    value={`₹${(
      (selectedPayment
        .transaction?.amount || 0) -

      (
        (
          (selectedPayment
            .razorpayPayment
            ?.fee || 0) +

          (
            selectedPayment
              .razorpayPayment
              ?.tax || 0
          )
        ) / 100
      )
    ).toFixed(2)}`}
  />

  <Row
    label="Error"
    value={
      selectedPayment
        .razorpayPayment
        ?.error_description ||
      "None"
    }
  />

</div>

            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Payments;
// import React, { useEffect, useState } from "react";

// import "../css/Payments.css";

// const Payments = () => {

//   const [payments, setPayments] = useState([]);

//   const [loading, setLoading] = useState(true);

//   const [selectedPayment, setSelectedPayment] =
//     useState(null);

//   useEffect(() => {
//     fetchPayments();
//   }, []);

//   const fetchPayments = async () => {

//     try {

//       setLoading(true);

//       const res = await fetch(
//         "http://localhost:5000/api/admin/payments"
//       );

//       if (!res.ok) {
//         throw new Error(
//           "Failed to fetch payments"
//         );
//       }

//       const data = await res.json();

//       console.log("PAYMENTS:", data);

//       if (data.success) {

//         setPayments(data.data || []);

//       } else {

//         setPayments([]);
//       }

//     } catch (error) {

//       console.error(
//         "FETCH PAYMENTS ERROR:",
//         error
//       );

//       setPayments([]);

//     } finally {

//       setLoading(false);
//     }
//   };

//   /**
//    * CLOSE MODAL
//    */
//   const closeModal = () => {
//     setSelectedPayment(null);
//   };

//   return (
//     <div className="payments-page">

//       {/* HEADER */}
//       <div className="payments-header">

//         <div>

//           <h1>
//             Payments
//           </h1>

//           <p>
//             Monitor all booking payments
//             and transaction details
//           </p>
//         </div>

//         <div className="payments-count">
//           {payments.length} Payments
//         </div>
//       </div>

//       {/* TABLE */}
//       <div className="payments-table-wrapper">

//         <table className="payments-table">

//           <thead>

//             <tr>

//               <th>
//                 Booking ID
//               </th>

//               <th>
//                 Customer
//               </th>

//               <th>
//                 Vehicle
//               </th>

//               <th>
//                 Amount
//               </th>

//               <th>
//                 Status
//               </th>

//               <th>
//                 Method
//               </th>

//               <th>
//                 Payment ID
//               </th>

//               <th>
//                 Action
//               </th>

//             </tr>

//           </thead>

//           <tbody>

//             {loading ? (

//               <tr>

//                 <td colSpan="8">
//                   Loading payments...
//                 </td>

//               </tr>

//             ) : payments.length === 0 ? (

//               <tr>

//                 <td colSpan="8">
//                   No payments found
//                 </td>

//               </tr>

//             ) : (

//               payments.map((item, index) => {

//                 const customer =
//                   item.customer || {};

//                 const transaction =
//                   item.transaction || {};

//                 const razorpayPayment =
//                   item.razorpayPayment || {};

//                 return (

//                   <tr key={index}>

//                     {/* BOOKING ID */}
//                     <td className="booking-id">

//                       {item.booking_id}

//                     </td>

//                     {/* CUSTOMER */}
//                     <td>

//                       <div className="customer-name">

//                         {customer.full_name || "-"}

//                       </div>

//                       <div className="customer-phone">

//                         {customer.phone || "-"}

//                       </div>

//                     </td>

//                     {/* VEHICLE */}
//                     <td>

//                       {item.modelname || "-"}

//                     </td>

//                     {/* AMOUNT */}
//                     <td>

//                       ₹{transaction.amount || 0}

//                     </td>

//                     {/* STATUS */}
//                     <td>

//                       <span
//                         className={`status-badge ${
//                           transaction.payment_status
//                         }`}
//                       >

//                         {transaction.payment_status ||
//                           "-"}

//                       </span>

//                     </td>

//                     {/* METHOD */}
//                     <td>

//                       {razorpayPayment.method ||
//                         "-"}

//                     </td>

//                     {/* PAYMENT ID */}
//                     <td className="payment-id">

//                       {transaction.payment_id ||
//                         "-"}

//                     </td>

//                     {/* ACTION */}
//                     <td>

//                       <button
//                         className="view-btn"
//                         onClick={() =>
//                           setSelectedPayment({
//                             ...item,
//                             customer,
//                             transaction,
//                             razorpayPayment,
//                           })
//                         }
//                       >

//                         View

//                       </button>

//                     </td>

//                   </tr>
//                 );
//               })
//             )}

//           </tbody>
//         </table>
//       </div>

//       {/* MODAL */}
//       {selectedPayment && (

//         <div className="payment-modal-overlay">

//           <div className="payment-modal">

//             {/* MODAL HEADER */}
//             <div className="modal-header">

//               <h2>
//                 Payment Details
//               </h2>

//               <button
//                 className="close-btn"
//                 onClick={closeModal}
//               >
//                 ×
//               </button>
//             </div>

//             {/* MODAL CONTENT */}
//             <div className="modal-content">

//               {/* BOOKING */}
//               <div className="detail-group">

//                 <h3>
//                   Booking
//                 </h3>

//                 <p>
//                   <strong>
//                     Booking ID:
//                   </strong>{" "}

//                   {
//                     selectedPayment.booking_id
//                   }
//                 </p>

//                 <p>
//                   <strong>
//                     Vehicle:
//                   </strong>{" "}

//                   {
//                     selectedPayment.modelname
//                   }
//                 </p>

//                 <p>
//                   <strong>
//                     Price:
//                   </strong>{" "}

//                   ₹
//                   {
//                     selectedPayment.transaction
//                       ?.amount
//                   }
//                 </p>

//               </div>

//               {/* CUSTOMER */}
//               <div className="detail-group">

//                 <h3>
//                   Customer
//                 </h3>

//                 <p>
//                   <strong>
//                     Name:
//                   </strong>{" "}

//                   {
//                     selectedPayment.customer
//                       ?.full_name
//                   }
//                 </p>

//                 <p>
//                   <strong>
//                     Phone:
//                   </strong>{" "}

//                   {
//                     selectedPayment.customer
//                       ?.phone
//                   }
//                 </p>

//                 <p>
//                   <strong>
//                     Email:
//                   </strong>{" "}

//                   {
//                     selectedPayment.customer
//                       ?.email
//                   }
//                 </p>

//                 <p>
//                   <strong>
//                     City:
//                   </strong>{" "}

//                   {
//                     selectedPayment.customer
//                       ?.city
//                   }
//                 </p>

//               </div>

//               {/* PAYMENT */}
//               <div className="detail-group">

//                 <h3>
//                   Payment
//                 </h3>

//                 <p>
//                   <strong>
//                     Status:
//                   </strong>{" "}

//                   {
//                     selectedPayment.transaction
//                       ?.payment_status
//                   }
//                 </p>

//                 <p>
//                   <strong>
//                     Payment ID:
//                   </strong>{" "}

//                   {
//                     selectedPayment.transaction
//                       ?.payment_id
//                   }
//                 </p>

//                 <p>
//                   <strong>
//                     Method:
//                   </strong>{" "}

//                   {
//                     selectedPayment
//                       .razorpayPayment
//                       ?.method || "-"
//                   }
//                 </p>

//                 <p>
//                   <strong>
//                     Bank:
//                   </strong>{" "}

//                   {
//                     selectedPayment
//                       .razorpayPayment
//                       ?.bank || "-"
//                   }
//                 </p>

//                 <p>
//                   <strong>
//                     VPA:
//                   </strong>{" "}

//                   {
//                     selectedPayment
//                       .razorpayPayment
//                       ?.vpa || "-"
//                   }
//                 </p>

//                 <p>
//                   <strong>
//                     RRN:
//                   </strong>{" "}

//                   {
//                     selectedPayment
//                       .razorpayPayment
//                       ?.acquirer_rrn || "-"
//                   }
//                 </p>

//               </div>

//               {/* GATEWAY */}
//               <div className="detail-group">

//                 <h3>
//                   Gateway Details
//                 </h3>

//                 <p>
//                   <strong>
//                     Razorpay Status:
//                   </strong>{" "}

//                   {
//                     selectedPayment
//                       .razorpayPayment
//                       ?.status || "-"
//                   }
//                 </p>

//                 <p>
//                   <strong>
//                     Fee:
//                   </strong>{" "}

//                   ₹
//                   {
//                     selectedPayment
//                       .razorpayPayment
//                       ?.fee || 0
//                   }
//                 </p>

//                 <p>
//                   <strong>
//                     Tax:
//                   </strong>{" "}

//                   ₹
//                   {
//                     selectedPayment
//                       .razorpayPayment
//                       ?.tax || 0
//                   }
//                 </p>

//                 <p>
//                   <strong>
//                     Refunded:
//                   </strong>{" "}

//                   ₹
//                   {
//                     selectedPayment
//                       .razorpayPayment
//                       ?.amount_refunded || 0
//                   }
//                 </p>

//                 <p>
//                   <strong>
//                     Error:
//                   </strong>{" "}

//                   {
//                     selectedPayment
//                       .razorpayPayment
//                       ?.error_description || "None"
//                   }
//                 </p>

//               </div>

//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Payments;